import { createContext, useContext, useEffect, useState, useMemo } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cc_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("cc_cart", JSON.stringify(items)); }, [items]);

  const add = (line) => {
    setItems((prev) => {
      const i = prev.findIndex((x) => x.product_id === line.product_id && x.variant_id === line.variant_id);
      if (i >= 0) {
        const copy = [...prev];
        copy[i] = { ...copy[i], quantity: copy[i].quantity + line.quantity };
        return copy;
      }
      return [...prev, line];
    });
    setOpen(true);
  };
  const update = (idx, qty) => setItems((prev) => prev.map((x, i) => (i === idx ? { ...x, quantity: Math.max(1, qty) } : x)));
  const remove = (idx) => setItems((prev) => prev.filter((_, i) => i !== idx));
  const clear = () => setItems([]);

  const count = items.reduce((a, x) => a + x.quantity, 0);
  const subtotal = items.reduce((a, x) => a + x.price * x.quantity, 0);

  const value = useMemo(() => ({ items, add, update, remove, clear, count, subtotal, open, setOpen }), [items, open, count, subtotal]);

  return (
    <CartCtx.Provider value={value}>
      {children}
    </CartCtx.Provider>
  );
}
